/**
 * One-click add to cart for product tiles (carousels, collection and search grids).
 * Delegated so it also works for tiles Algolia renders after page load.
 */
(function () {
  const SELECTOR = '[data-tile-add-to-cart]';
  const SUCCESS_MS = 1600;

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function setState(button, state) {
    button.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) button.classList.add(state);
    button.toggleAttribute('aria-busy', state === 'is-loading');
  }

  async function addToCart(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cart = getCart();
    setState(button, 'is-loading');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    try {
      const response = await fetch(window.routes.cart_add_url, config);
      const data = await response.json();

      if (data.status) {
        setState(button, 'is-error');
        button.title = data.description || data.message || 'Could not add to cart';
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'tile-add-to-cart',
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        setTimeout(() => setState(button, null), SUCCESS_MS);
        return;
      }

      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'tile-add-to-cart',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
        return;
      }

      setState(button, 'is-added');
      setTimeout(() => setState(button, null), SUCCESS_MS);

      if (typeof window.MembershipAutoDedupe === 'function') window.MembershipAutoDedupe();
    } catch (error) {
      console.error(error);
      setState(button, 'is-error');
      setTimeout(() => setState(button, null), SUCCESS_MS);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(SELECTOR);
      if (!button) return;
      // The button lives inside the tile link: keep the click from navigating.
      event.preventDefault();
      event.stopPropagation();
      addToCart(button);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const button = event.target.closest(SELECTOR);
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      addToCart(button);
    },
    true
  );
})();
